module.exports = __webpack_public_path__ + "img/news.fb063cd8.png";